module.exports = __webpack_public_path__ + "img/single-img-18-p-1080.0bfc73a1.jpg";